/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ConfirmStatus = {
    CONFIRMED: 'CONFIRMED',
    REJECTED: 'REJECTED'
} as const;
export type ConfirmStatus = typeof ConfirmStatus[keyof typeof ConfirmStatus];

